<template>
  <van-popup v-model="visible" class="vsim-popup" get-container="body" :overlay-style="{ background: 'rgba(0, 0, 0, 0.5)' }">
    <div class="popup-title">虚拟模拟器考核</div>
    <div class="popup-sub" v-if="summary">{{ summary }}</div>
    <div class="popup-sub" v-else-if="items.length">已通过 {{ passCount }}/{{ items.length }} 个病种</div>
    <div class="popup-list">
      <div v-if="!loading && !items.length" class="popup-empty">暂无进度数据</div>
      <div class="popup-row" v-for="item in items" :key="item.key">
        <span>{{ item.label }}</span>
        <span class="popup-status" :class="item.tone || (item.passed === undefined ? '' : item.passed ? 'pass' : 'fail')">{{ item.value || (item.passed === undefined ? '' : item.passed ? '已通过' : '未通过') }}</span>
      </div>
    </div>
    <button class="popup-btn" type="button" @click="visible = false">关闭</button>
  </van-popup>
</template>

<script>
export default {
  name: 'CampVsimPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    summary: {
      type: String,
      default: ''
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    // 已通过的考核项数量
    passCount () {
      return this.items.filter(item => item.passed).length
    }
  }
}
</script>

<style lang="less" scoped>
.vsim-popup {
  display: flex;
  flex-direction: column;
  width: 320px;
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;

  .popup-title {
    padding-top: 14px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.8);
  }

  .popup-sub {
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
    color: #81766f;
  }

  .popup-list {
    padding: 8px 16px 0;
  }

  .popup-empty {
    padding: 18px 0;
    text-align: center;
    font-size: 12px;
    color: #999;
  }

  .popup-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 51px;
    border-bottom: 1px solid #f3f3f3;
    font-size: 14px;
    font-weight: 400;
    color: #000;
  }

  .popup-status {
    font-size: 12px;
    font-weight: 500;

    &.pass {
      color: #53ce76;
    }

    &.fail {
      color: #999;
    }
  }

  .popup-btn {
    display: block;
    width: calc(~'100% - 32px');
    height: 40px;
    margin: 12px auto 16px;
    border: 0;
    border-radius: 20px;
    background: #f3f1f0;
    color: #81766f;
    font-size: 14px;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampVsimPopup.vue